import reframe from 'nike-re-framejs';
import { resolveDataLoadState } from '@/common/dataState';
import { List } from 'immutable';

reframe.regSub('sub::liveStreams.matches', db => db.getIn(['liveStreams', 'matches']));

reframe.regSub(
    'sub::liveStreams.matches.sorted',
    () => [reframe.subscribe(['sub::liveStreams.matches'])],
    ([matches = List()]) => matches.sortBy(m => m.getIn(['match', 'startTime']))
);

reframe.regSub(
    'sub::liveStreams.matches.sorted.ids',
    () => [reframe.subscribe(['sub::liveStreams.matches.sorted'])],
    ([matches]) => matches.keySeq()
);

reframe.regSub(
    'sub::liveStreams.match',
    () => [reframe.subscribe(['sub::liveStreams.matches'])],
    ([matches], [_, streamId]) => matches.get(streamId)
);

reframe.regSub(
    'sub::liveStreams.data-state',
    () => [reframe.subscribe(['sub::liveStreams.matches'])],
    ([matches]) => resolveDataLoadState(matches)
);
